const getUrlForImageUrl = (url) => {
  if (!url) return '';
  if (String(url || '').includes('http://') || String(url || '').includes('https://')) {
    return url
  }
  return [process.env.REACT_APP_IMAGE_URL, url].join('');
}
const getUrlForDownloadUrl = (url) => {
  if (!url) return '';
  if (String(url || '').includes('http://') || String(url || '').includes('https://')) {
    return url
  }
  return [process.env.REACT_APP_DOWNLOAD_URL, url].join('');
}
const getUrlForImageMobileUrl = (url) => {
  if (!url) return '';
  if (String(url || '').includes('http://') || String(url || '').includes('https://')) {
    return url
  }
  return [process.env.REACT_APP_IMAGE_MOBILE_URL, url].join('');
}

export {
  getUrlForImageUrl,
  getUrlForDownloadUrl,
  getUrlForImageMobileUrl
}
